<c-card *transloco="let t">
    <c-card-body class="px-2">


        <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-6">
            <h3>{{ t('Report: End Worker Shifts') }}</h3>
            <p> {{ t('Filter and end shifts for workers who are currently on shift') }}</p>
          </div>
        </div>



        <div class="card mb-2">
            <div class="card-header"data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">

                <form cForm >



                    <div class="row d-flex justify-content-center mb-2">
                        <label  class="col-sm-2 col-form-label text-end"  for="monitors">
                          <b>{{ t('Monitor') }}</b>
                        </label>
                        <div class="col-sm-4">
                          <ng-select
                          [items]="okService.monitors"
                          name="monitor"
                          [(ngModel)]="filter.monitors"
                          [multiple]="true"
                          bindLabel="name"
                          bindValue="id">
                          </ng-select>
                        </div>

                        <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                          <label  class="col-sm-2 col-form-label text-end" for="groups">
                            <b>{{ t('Group') }}</b>
                          </label>
                        <div class="col-sm-4">
                          <ng-select
                          [items]="okService.groups"
                          name="group"
                          [(ngModel)]="filter.groups"
                          [multiple]="true"
                          bindLabel="name"
                          bindValue="id">
                          </ng-select>
                        </div>
                      </ng-container>

                      </div>

                      <div class="row mb-3">
                        <label  class="col-sm-4 col-form-label text-end" for="search">
                          <b>{{ t('Search') }}</b>
                        </label>
                        <div class="col-sm-6">
                          <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="filter.search"/>
                        </div>
                      </div>

                  <div class="row mb-2 d-flex justify-content-center">
                    <label  class="col-sm-4 col-form-label text-end" for="search">
                      <b>{{ t('Added to OK Alone') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <c-input-group>
                        <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="created" name="created_datetime"  class="form-control" [disabled]="!enable_created"/> <input class="form-check-input filter-checkbox" type="checkbox" [(ngModel)]="enable_created" name="enable_created">
                      </c-input-group>
                    </div>
                  </div>
                  <div class="row mb-2 d-flex justify-content-center">
                    <label  class="col-sm-4 col-form-label text-end" for="search">
                      <b>{{ t('Shift Started') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <c-input-group>
                        <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="shift" name="shift_datetime"  class="form-control" [disabled]="!enable_shift"/> <input class="form-check-input filter-checkbox" type="checkbox"  [(ngModel)]="enable_shift" name="enable_shift">
                      </c-input-group>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                        <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                          <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                           {{ t('Clear Filter') }}
                        </span>
                      </button>
                    </div>
                </div>

                </form>

              </div>
            </div>
          </div>

          <div class="row mb-1">
            <c-col class="text-left">
                <button class="btn btn-danger text-white" (click)="clickEndShifts()" [disabled]="this.selected_workers.length == 0">{{ t('End Selected Worker Shifts' )}}</button>
            </c-col>
            <c-col class="text-end">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button class="btn btn-outline-info" (click)="selectAll()"><i class="fas fa-check-double"></i> {{ t('Select All') }}</button>
                    <button class="btn btn-outline-info" (click)="deSelectAll()"><i class="fas fa-times"></i> {{ t('Select None') }}</button>
                </div>
            </c-col>
            </div>

          <c-row *ngIf="workers">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    <th scope="col">{{ t('Date Added') }}</th>
                    <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col">{{ t('Groups') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers" [class.table-success]="selected_workers.includes(worker.id)" (click)="toggleWorker(worker.id)">
                      <td>
                        <button  cButton class="me-1 btn-sm btn-danger text-white" (click)="endWorkerShift(worker)">
                            {{ t('End Shift') }}
                        </button>
                      </td>
                      <td>
                        <span class="badge text-dark"
                        [class.bg-danger]="worker.status.status=='Help'"
                        [class.bg-success]="worker.status.status=='Working'"
                        [class.bg-warning]="worker.status.status=='Overdue'"
                        [class.text-white]="worker.status.status=='Help' || worker.status.status=='Working' || worker.status.status=='Overdue'"
                        >
                        {{worker.status.status}}
                        </span>
                      </td>
                      <td>
                        <input class="form-check-input" type="checkbox"  [checked]="selected_workers.includes(worker.id)"> &nbsp;
                        <span><b>{{worker.name}}</b></span>
                      </td>
                      <th scope="row">
                        <div>
                          <span class="badge bg-light text-dark">{{worker.pin}}</span>
                        </div>
                      </th>
                      <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td>
                      <td>
                        {{worker.created_at}}
                      </td>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.monitor_names}}</span>
                        </div>
                      </th>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.group_names}}</span>
                        </div>
                      </th>

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>
